<!-- STICKY NAVBAR – ALWAYS ON TOP -->
 <app-top-navbar></app-top-navbar>

<div class="about-container">
 <h1 style="text-align: center;">Coming Soon!</h1>
</div>


 <!-- FOOTER -->
 <app-bottom-footer></app-bottom-footer>